import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "./api";

const AuthCtx = createContext(null);
export const useAuth = () => useContext(AuthCtx);
export const homeFor = (u) => ({ admin: "/admin", inspector: "/inspector", builder: "/builder" }[u?.role] || "/customer");

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);

  const check = useCallback(async () => {
    if (!localStorage.getItem("pc_token")) { setUser(false); return; }
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
    } catch {
      localStorage.removeItem("pc_token");
      setUser(false);
    }
  }, []);

  useEffect(() => {
    if (window.location.hash?.includes("session_id=")) { setUser(false); return; }
    check();
  }, [check]);

  const accept = (data) => {
    localStorage.setItem("pc_token", data.token);
    setUser(data.user);
    return data.user;
  };
  const login = async (email, password) => accept((await api.post("/auth/login", { email, password })).data);
  const google = async (session_id) => accept((await api.post("/auth/google/session", { session_id })).data);
  const logout = () => { localStorage.removeItem("pc_token"); setUser(false); };

  return <AuthCtx.Provider value={{ user, login, google, logout }}>{children}</AuthCtx.Provider>;
}
